module.exports = __webpack_public_path__ + "img/icon_refresh@3x.b76bd199.png";